<template>
  <div id="msgDlg">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-snackbar
        v-model="snackbar_disp"
        :color="color"
        :top="snackbar_top"
        :bottom="snackbar_bottom"
        :multi-line="snackbar_multi_line"
        :timeout="snackbar_timeout"
      >
        <v-container class="pa-0">
          <v-row
            dense
            style="margin-top:0px; padding-top:0px;"
          >
            <v-col
              cols="9"
              align="left"
              style="margin-top:0px; padding-top:0px;"
            >
              {{ title }}
            </v-col>
            <v-col
              cols="3"
              align="right"
              style="margin-top:0px; padding-top:0px;"
            >
              <v-btn
                class="mt-0 mb-2 pa-0"
                icon
                color="#FFFFFF"
                text
                @click="snackbar_disp = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            align="center"
          >
            <v-col
              cols="1"
              align="center"
            >
              <v-icon color="white">
                {{ msg_icon }}
              </v-icon>
            </v-col>
            <v-col
              cols="11"
              align="center"
            >
              <span :class="model_msg_class">{{ msg }}</span>
              <br v-if="msgdlg_img_src !== ''">
              <img
                v-if="msgdlg_img_src !== ''" 
                :src="msgdlg_img_src"
              >
              <br v-if="msgdlg_img_src !== ''">
            </v-col>
          </v-row>
        </v-container>
      </v-snackbar>

      <v-dialog
        v-model="model_dialog"
        persistent
        max-width="100%"
        :width="model_width"
      >
        <v-card :color="color">
          <v-row
            style="height:50px"
            class="ma-0 pa-2"
          >
            <v-col
              cols="10"
              align="left"
              style="margin-top:0px; padding-top:0px;"
            >
              <span :class="model_msg_class">{{ title }}</span>
            </v-col>
            <v-col
              cols="2"
              align="right"
              style="margin-top:0px; padding-top:0px;"
            >
              <v-btn
                class="mt-0 mb-2 pa-0"
                icon
                large
                color="#FFFFFF"
                text
                align="left"
                @click="onClickCancel"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card-text class="pa-4">
            <v-row
              dense
              max-width="100"
              style="margin-top:0px; padding-top:0px;"
            >
              <v-col
                v-if="model_button_type !== 'ok_cancel'"
                cols="1"
                align="center"
                style="margin-top:0px; padding-top:0px;"
              >
                <v-icon
                  color="white"
                >
                  {{ msg_icon }}
                </v-icon>
              </v-col>
              <v-col
                :cols="model_button_type !== 'ok_cancel' ? 11 : 12"
                align="center"
                style="margin-top:0px; padding-top:0px;"
              >
                <span
                  :class="model_msg_class"
                  style="white-space:pre-wrap;"
                >{{ msg }}</span>
                <div v-if="!model_input_type">
                  <img :src="msgdlg_img_src">
                </div>
              </v-col>
            </v-row>
            <v-row
              dense
              max-width="100"
              style="margin-top:0px; padding-top:0px;"
            >
              <v-col
                v-if="model_input_type === 'onetimepass'"
                cols="12"
                align="left"
                style="margin-top:0px; padding-top:0px;"
              >
                <v-text-field
                  v-model="model_input_val"
                  label="ワンタイムパスワード(※)"
                  required
                  counter="6"
                  maxlength="6"
                  :rules="[v => !!v || &quot;ワンタイムパスワードは必須です&quot;]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="model_button_type === 'ok_cancel'">
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="onClickCancel"
            >
              キャンセル
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="onClickOk"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>

const def_timeout = 5000;
const def_title = 'クラウドフォルダー';
const color_success = 'success';
const color_info = 'info';
const color_warn = 'orange darken-3';
const color_error = 'error';
const icon_success = 'mdi-check-circle';
const icon_info = 'mdi-alert-circle';
const icon_warn = 'mdi-alert';
const icon_error = 'mdi-close-circle';
const def_model_width = 450;

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    snackbar_disp : false,
    snackbar_top : true,
    snackbar_bottom : true,
    snackbar_multi_line : true,
    snackbar_timeout : def_timeout,
    color : '',
    title : '',
    msg : '',
    msg_icon: '',
    msgdlg_img_src : '',
    model_dialog: false,
    model_width: def_model_width,
    model_title_class: '',
    model_msg_class: '',
    model_result: false,
    model_button_type: '',
    model_input_type: '',
    model_input_val:'',
    okCancelResolve : null,
    valid: true,
  }),
  methods: {
    // ダイアログを開く前にデータをクリア
    clear(){
      this.snackbar_disp = false;
      this.snackbar_top = true;
      this.snackbar_bottom = true;
      this.snackbar_multi_line = true;
      this.snackbar_timeout = def_timeout;
      this.color = '';
      this.title = def_title;
      this.msg = '';
      this.msg_icon = '',
      this.msgdlg_img_src = '';
      this.model_dialog = false;
      this.model_width = def_model_width;
      this.model_title_class = '';
      this.model_msg_class = '';
      this.model_result = false;
      this.model_button_type = '',
      this.model_input_type = '',
      this.model_input_val = '';
      this.okCancelResolve = null;
      this.$refs.form.reset();
    },
    // デフォルト秒たつと自動で消えるSuccessメッセージ
    showSuccess(msg, img_src) {
      this.showSnackbarCore(msg, img_src, color_success, icon_success, def_timeout);
    },
    // デフォルト秒たつと自動で消えるInfoメッセージ
    showInfo(msg, img_src) {
      this.showSnackbarCore(msg, img_src, color_info, icon_info, def_timeout);
    },
    // デフォルト秒たつと自動で消えるWarnメッセージ
    showWarn (msg, img_src) {
      this.showSnackbarCore(msg, img_src, color_warn, icon_warn, def_timeout);
    },
    // デフォルト秒たつと自動で消えるErrorメッセージ
    showError (msg, img_src) {
      this.showSnackbarCore(msg, img_src, color_error, icon_error, def_timeout);
    },
    // デフォルト秒たつと自動で消えるメッセージ コア処理
    showSnackbarCore (msg, img_src, color, icon, timeout) {
      this.clear();
      this.snackbar_disp = true;
      this.msg = msg;
      if(img_src){
        this.msgdlg_img_src = img_src;
      }

      this.model_title_class = 'white--text';
      this.model_msg_class = 'white--text';

      this.msg_icon = icon;
      this.color = color;
      this.snackbar_timeout = timeout;
    },
    // 自動で消えないSuccessメッセージ
    showModalSuccess(msg, img_src, width) {
      this.showModalCore(null, msg, img_src, color_success, icon_success, width);
    },
    // 自動で消えないInfoメッセージ
    showModalInfo(msg, img_src, width) {
      this.showModalCore(null, msg, img_src, color_info, icon_info, width);
    },
    // 自動で消えないWarnメッセージ
    showModalWarn (msg, img_src, width) {
      this.showModalCore(null, msg, img_src, color_warn, icon_warn, width);
    },
    // 自動で消えないErrorメッセージ
    showModalError (msg, img_src, width) {
      this.showModalCore(null, msg, img_src, color_error, icon_error, width);
    },
    // 自動で消えないメッセージ コア処理
    showModalCore (title, msg, img_src, color, icon, width) {
      this.clear();
      if(title){
        this.title = title;
      } else {
        this.title = def_title;
      }

      this.model_dialog = true;
      if(width){
        this.model_width = width;
      }

      this.model_title_class = 'white--text';
      this.model_msg_class = 'white--text';

      this.msg_icon = icon;
      this.color = color;
      this.msg = msg;
      this.model_button_type = 'close';

      this.msg = msg;
      if(img_src){
        this.msgdlg_img_src = img_src;
      }
    },
    // OK,Cancelボタン
    showOkCancel (title, msg, model_input_type) {
      this.clear();
      if(title){
        this.title = title;
      } else {
        this.title = def_title;
      }

      this.model_dialog = true;

      this.model_title_class = 'black--text';
      this.model_msg_class = 'black--text';

      this.color = '';
      this.msg = msg;
      this.model_button_type = 'ok_cancel';
      this.model_input_type = model_input_type;

      let _this = this;
      return new Promise(function(resolve) {
        _this.okCancelResolve = resolve;
      });
    },
    onClickOk() {
      if (!this.$refs.form.validate()) {
        return;
      }
      
      this.model_dialog = false;
      if(!this.model_input_type){
        this.okCancelResolve(true);
      } else if(this.model_input_type === 'onetimepass'){
        this.okCancelResolve({okCancelResult :true , onetimepass: this.model_input_val});
      }
    },
    onClickCancel() {
      // コールバック関数がない場合を考慮
      if(!this.okCancelResolve){
        this.onClickClose();
        return;
      }

      if(!this.model_input_type){
        this.okCancelResolve(false);
      } else if(this.model_input_type === 'onetimepass'){
        this.okCancelResolve({okCancelResult :false , onetimepass: null});
      }
      // キャンセルは必ず画面を閉じる
      this.onClickClose();
    },
    onClickClose(){
      this.model_dialog = false;
    },
  },
};
</script>
